// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gEjV-","formToggle":"styles_formToggle__RsqJf"};